export default () => ({
  waitTimeRateList: [],
});
